import jsPDF from 'jspdf';
import 'jspdf-autotable';
import HTTPRequest from '../../../controllers/httpRequest';
import secureStorage from '../../../controllers/secureStorage.js';
import moment from 'moment';
import { decrypt } from "../../../utilities.js"

var printOthsin = {
    methods: {
        async printOTHSIN(isDefaultPrint, customFont, summaryData, component_x) {
            component_x.spinning = true;

            let tabulatorInstance = component_x.$refs.tabulator.getInstance();
            let tableData = tabulatorInstance.getData();
            let documentDetails = component_x.documentDetails;

            // console.log(`Printing OTHSIN with isDefaultPrint=${isDefaultPrint} and customFont=${customFont} and this ${component_x}`, component_x);
            // console.log(component_x.documentDetails, component_x);
            // console.log('tabledata',tableData)
            const doc = new jsPDF('p', 'pt', 'a4');
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            const documentDate = moment(documentDetails.document_date, 'YYYY-MM-DD');
            const targetDate = moment(documentDetails.target_date, 'YYYY-MM-DD');
            const terms = documentDate.diff(targetDate, 'days');
            const accountName = secureStorage.getItem("accountName")
            const isPIML = accountName.toLowerCase().includes('piml')
            var documentHistory = await HTTPRequest.getRequest(component_x.endPoint + "document_action_histories/" + documentDetails.id + "?field_name=document_id", null);


            let xLeftKey = 35;
            let requestingSiteId = component_x.documentDetails.site_id.key;

            let siteData = await HTTPRequest.getRequest(`${component_x.endPoint}sites/${requestingSiteId}`, null, null);
            let companyData = await HTTPRequest.getRequest(`${this.endPoint}companies/${siteData.company_id}`, null, null);
            // let customer = await HTTPRequest.getRequest(`${component_x.endPoint}customers/${component_x.customer.key}`, null, null);
            let b2b = await HTTPRequest.getRequest(`${this.endPoint}b2b_customers/${this.b2bCustomer}`, null, null);

            // since this is not being saved as country_id on b2b_customer on NS through lynexus > RMS, we need to map it here
            // Netsuite (via Lynexus integ -> RMS) saves `country_id` as ISO code (e.g. "DK")
            // Printout requires full country name, so we need to map codes here
            // first mapping from get_valid_countries API (active countries in RMS), then fallback to a hardcoded map for missing entries like DK -> DENMARK
            const FALLBACK_COUNTRY_MAP = {
                "DK": "DENMARK",
                // add more unmapped codes as needed
            };

            async function getCountryName(code, endPoint) {
                try {
                    let response = await HTTPRequest.getRequest(`${endPoint}countries/get_valid_countries`, null, null);
                    let countries = response || [];
                    let found = countries.find(c => c.code === code);

                    return found ? found.name : (FALLBACK_COUNTRY_MAP[code] || code || "");
                } catch (e) {
                    console.error("getCountryName error:", e);
                    return FALLBACK_COUNTRY_MAP[code] || code || "";
                }
            }

            let countryName = await getCountryName(b2b.country_id, this.endPoint);
            let street_or_province = b2b.province_name || "";
            let barangay = b2b.barangay_name || "";
            let city = b2b.city_name || "";
            let zip_code = b2b.zip_code || "";
            let address_1 = b2b.address || "";

            let formattedCustomerAddress = `${address_1}, ${barangay}, ${zip_code}, ${city}, ${street_or_province}, ${countryName}`;
            let isPrinted = false;

            // Check if any action in documentHistory is "Print Document"
            for (let i = 0; i < documentHistory.length; i++) {
                if (documentHistory[i].action === "Print Document") {
                    isPrinted = true;
                    break;
                }
            }

            // Function to add header
            function addHeader(doc, siteData, companyData, documentDetails, xLeftKey, pageWidth, pageNumber, pageCount) {
                // Title
                doc.setFontSize(12);
                doc.setFontStyle("bold");
                doc.text(`${siteData.company_name}`, xLeftKey, 30);

                // Subtitle
                doc.setFontSize(8);
                doc.setFontStyle("normal");
                let yPosition = 40;
                let lineHeight = 10;
                let companyAddress = doc.splitTextToSize(`${companyData.address || ''}`, 250);

                companyAddress.forEach((line, index) => {
                    doc.text(line, xLeftKey, yPosition + (index * lineHeight));
                });

                let companyDetailsY = yPosition + (companyAddress.length * lineHeight);
                doc.text(`VAT REG TIN: ${companyData.tin || ''}`, xLeftKey, companyDetailsY);
                doc.text(`TEL. NO.: ${companyData.telephone || ''}`, xLeftKey, companyDetailsY + lineHeight);

                // Invoice Header
                doc.setFontSize(10);
                doc.setFontStyle("bold");
                doc.text('SALES INVOICE', pageWidth - 120, 45);
                doc.setFontSize(8);
                doc.setFontStyle("normal");
                doc.text(`${documentDetails.cas_no || ''}`, pageWidth - 120, 60);
                doc.text(`${isPrinted ? 'REPRINTED' : 'ORIGINAL'} COPY`, pageWidth - 120, 70);

                // // Page Number
                // doc.setFontSize(8);
                // doc.text(`Page ${pageNumber} of ${pageCount}`, pageWidth - 40, 20, { align: 'right' });
            }

            // generate the first serial number from the prefix
            function generateFirstSerialNumber(casNo) {
                // split the cas_no to extract the prefix and current serial number
                const parts = casNo.split("-");
                const prefix = parts.slice(0, -1).join("-");
                const firstSerialNumber = `${prefix}-99999999`;
                return firstSerialNumber;
            }

            const currentSerialNumber = handleNull(documentDetails.cas_no);
            const firstSerialNumber = generateFirstSerialNumber(currentSerialNumber);

            // Function to add footer
            function addFooter(doc, pageWidth, pageHeight, pageNumber, pageCount) {
                const currentDate = moment().format('MM/DD/YYYY');
                const currentTime = moment().format('HH:mm');
                var userName = secureStorage.getItem("userName");

                doc.setFontSize(8);
                doc.setFontStyle("normal");
                doc.text(`Acknowledgement Certificate: ${handleNull(companyData.cas_permit_number)}`, 40, pageHeight - 50);
                doc.text(`Date Issued: ${moment(companyData.acknowledgement_receipt_date_issue).format("MMMM D, YYYY")}`, 40, pageHeight - 35);
                // doc.text(`Serial Number Range: ${currentSerialNumber + ' - ' + firstSerialNumber || ''}`, 40, pageHeight - 20);
                // Some companies have no configured series range, add fallback/guard against null/undefined values
                const seriesRange = handleNull(companyData.series_number_range);
                const seriesParts = String(seriesRange).split('-');
                const seriesStart = seriesParts[0] || '';
                const seriesEnd = seriesParts[1] || '';
                const companyCode = handleNull(documentDetails.company_code);
                doc.text(`Serial Number Range: ${'SI' + '-' + companyCode + '-' + seriesStart + ' - ' + 'SI' + '-' + companyCode + '-' + seriesEnd}`, 40, pageHeight - 20);
                doc.text(`${userName}`, pageWidth - 40, pageHeight - 35, { align: 'right' });
                doc.text(`${documentDetails.status}`, pageWidth - 40, pageHeight - 50, { align: 'right' });
                doc.text(`${currentDate} ${currentTime}`, pageWidth - 40, pageHeight - 20, { align: 'right' });
                // doc.text(`Page ${pageNumber} of ${pageCount}`, pageWidth - 40, pageHeight - 35, { align: 'right' });
            }

            function handleNull(value) {
                return value == null ? '' : value;
            }

            function wrapTextToWidth(text, maxWidth) {
                const str = String(handleNull(text));
                if (!str) return [''];
                const lines = [];
                let current = '';
                for (const char of str) {
                    const candidate = current + char;
                    if (doc.getTextWidth(candidate) > maxWidth && current !== '') {
                        lines.push(current);
                        current = char;
                    } else {
                        current = candidate;
                    }
                }
                if (current !== '') lines.push(current);
                return lines.length ? lines : [''];
            }

            // Adjust the margin to 0.5 inch
            doc.setProperties({ margin: 0.1 * 72 }); // 0.5 inch in points

            // Add the header on the first page
            addHeader(doc, siteData, companyData, documentDetails, xLeftKey, pageWidth, 1, 1);

            doc.setFontSize(8);
            const infoTop = 100;
            const infoRowGap = 30;   // default spacing between single-line rows
            const infoLineHeight = 10;

            let customerName = handleNull(b2b.name) || "No Customer Name";
            let customerAddress = handleNull(formattedCustomerAddress) || "No Customer Address";

            // Left column rows
            const leftRows = [
                ['Sold to:', doc.splitTextToSize(`${decrypt(customerName)}`, 250)],
                ['Address:', doc.splitTextToSize(`${customerAddress}`, 250)],
                ['Tin:', wrapTextToWidth(`${decrypt(b2b.tin) || ''}`, 250)],
                ['Remarks:', wrapTextToWidth(documentDetails.remark, 250)],
            ];
            // Right column values start at x=450. Wrap them to stop before the
            // info box / table right border (box right edge is at pageWidth - 30)
            // with a small pad so the text never touches or exceeds the border.
            const rightValueX = 450;
            const rightValueMaxWidth = pageWidth - 30 - rightValueX - 8;
            const rightRows = [
                ['Date:', wrapTextToWidth(documentDetails.document_date, rightValueMaxWidth)],
                ['P.O. No.:', wrapTextToWidth(documentDetails.oc_ref_no, rightValueMaxWidth)],
                ['Terms:', wrapTextToWidth(documentDetails.payment_term_id.label, rightValueMaxWidth)],
            ];

            const renderColumn = (rows, labelX, valueX) => {
                let y = infoTop;
                rows.forEach(([label, valueLines]) => {
                    doc.setFontStyle("bold");
                    doc.text(label, labelX, y);
                    doc.setFontStyle("normal");
                    doc.text(valueLines, valueX, y);
                    y += Math.max(infoRowGap, valueLines.length * infoLineHeight);
                });
                return y;
            };

            const leftBottomY = renderColumn(leftRows, xLeftKey, 110);
            const rightBottomY = renderColumn(rightRows, 400, 450);
            const infoBottomY = Math.max(leftBottomY, rightBottomY);

            // Draw the box around the company info, sized to fit the content.
            doc.setDrawColor(0, 0, 0); // Black color
            doc.setLineWidth(1);
            doc.rect(30, 85, pageWidth - 60, (infoBottomY - 85) + 2);

            // Start the table just below the info box, with a little breathing room.
            const othsinTableStartY = infoBottomY + 12;

            function formatNumber(value) {
                if (!value) return '0.00';
                return parseFloat(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            }

            // Table Data
            const tableColumn = [
                { header: 'Item No.', dataKey: 'barcode' },
                { header: 'Quantity', dataKey: 'quantity' },
                { header: 'Unit', dataKey: 'unit_name' },
                { header: 'Description', dataKey: 'product_name' },
                // { header: 'Size', dataKey: 'size' },
                // { header: 'Color', dataKey: 'color' },
                { header: 'Unit Price', dataKey: 'price' },
                { header: 'Line Discount', dataKey: 'discount' },
                //{ header: 'Amount', dataKey: 'subtotal' },
            ];

            //Use invoice total if SI from LIQ
            if (documentDetails.order_source == 'LIQUIDATION') {
                tableColumn.push({ header: 'Amount', dataKey: 'invoice_total' })
            } else if (['BARTER TOOL', 'BARTER TOOL 3P'].includes(this.documentDetails.order_source)) {
                tableColumn.push({ header: 'Amount', dataKey: 'barter_tool_gross' })
            } else {
                tableColumn.push({ header: 'Amount', dataKey: 'subtotal' })
            }

            if (isPIML) {
                const descriptionIndex = tableColumn.findIndex(col => col.header === 'Description');

                tableColumn.splice(descriptionIndex + 1, 0,
                    { header: 'Size', dataKey: 'size' },
                    { header: 'Color', dataKey: 'color' }
                );

                const descriptionColumn = tableColumn.find(col => col.header === 'Description');
                if (descriptionColumn) {
                    descriptionColumn.dataKey = 'style_name';
                }
            }
            function extractValues(data, keys) {
                return data.map(row => {
                    const newRow = {};
                    keys.forEach(column => {
                        if (row.hasOwnProperty(column.dataKey)) {
                            if (column.dataKey === 'price') {
                                newRow[column.dataKey] = formatNumber(row[column.dataKey]);
                            } else if (column.dataKey === 'subtotal') {
                                //No need to add trade discount >> see document_line serializer
                                newRow[column.dataKey] = formatNumber(Number(row[column.dataKey]));
                            } else if (column.dataKey === 'invoice_total' || column.dataKey === 'barter_tool_gross') {
                                newRow[column.dataKey] = formatNumber(Number(row[column.dataKey]));
                            } else if (column.dataKey === 'discount') {
                                newRow[column.dataKey] = formatNumber(Number(row[column.dataKey]));
                            } else {
                                newRow[column.dataKey] = row[column.dataKey];
                            }
                        }
                    });
                    return newRow;
                });
            }

            const extractedData = extractValues(tableData, tableColumn);
            const totalQuantity = tableData.reduce((sum, row) => {
                return sum + Number(row.quantity || 0);
            }, 0);

            // let vat_exempt = "0.00"
            // let total_amount = "0.00"
            // let zero_rated = "0.00"

            let vatableSales = summaryData.net_amount
            let vatExemptSales = 0
            let zeroRated = 0
            let vatAmount = '0.00'
            console.log(documentDetails)
            if (documentDetails.party_tax_type == 'V') {
                vatableSales = (documentDetails.order_source == 'LIQUIDATION' || documentDetails.order_source == 'BARTER TOOL' || documentDetails.order_source == 'BARTER TOOL 3P') ? Number(documentDetails.net_amount_without_tax) : summaryData.vatables
                vatAmount = (documentDetails.order_source == 'LIQUIDATION' || documentDetails.order_source == 'BARTER TOOL' || documentDetails.order_source == 'BARTER TOOL 3P') ? Number(documentDetails.tax_amount) : summaryData.vat_amount
            } else if (documentDetails.party_tax_type == 'X') {
                vatableSales = 0
                vatExemptSales = summaryData.net_amount
            } else if (documentDetails.party_tax_type == 'Z') {
                vatableSales = 0
                zeroRated = summaryData.net_amount
            }

            //Totals
            const totalsData = [
                { label: 'Total Sales, Net of Line Discount', value: formatNumber(summaryData.gross_amount - summaryData.item_discount) },
                { label: 'Less: Invoice Discount', value: formatNumber(Number(documentDetails.amount_header_discount) + Number(documentDetails.trade_discount)) },
                { label: 'Net Sales', value: formatNumber(summaryData.net_amount) }
            ];

            //Vat Calculations
            const vatCalculationsData = [
                { label: 'Total Sales (VAT Inclusive)', value: formatNumber(summaryData.net_amount) },
                { label: 'Less VAT', value: formatNumber(vatAmount) },
                { label: 'Amount NET of VAT', value: formatNumber(vatableSales || vatExemptSales || zeroRated) },
                { label: 'Less: SC/PWD Discount', value: '0.00' },
                { label: 'Amount Due', value: formatNumber(vatableSales || vatExemptSales || zeroRated) },
                { label: 'Add: VAT', value: formatNumber(vatAmount) },
                { label: 'TOTAL AMOUNT DUE', value: formatNumber(summaryData.net_amount) }
            ];

            const vatDetails = [
                { label: '', value: '' },
                { label: '', value: '' },
                { label: 'VATable Sales', value: formatNumber(vatableSales) },
                { label: 'VAT-Exempt Sales ', value: formatNumber(vatExemptSales) },
                { label: 'Zero Rated Sales', value: formatNumber(zeroRated) },
                { label: 'VAT Amount ', value: formatNumber(vatAmount) },
            ];

            let extractedDataWithTotals
            if (isPIML) {
                extractedDataWithTotals = [
                    ...extractedData,
                    {},
                    ...totalsData.map(total => ({ barcode: '', quantity: '', unit_name: '', style_name: '', size: '', color: '', price: total.label, discount: '', subtotal: total.value })),
                    {},
                    {},
                    {},
                ];
            } else {
                extractedDataWithTotals = [
                    ...extractedData,
                    {},
                    ...totalsData.map(total => ({ barcode: '', quantity: '', unit_name: '', product_name: '', price: total.label, discount: '', subtotal: total.value })),
                    {},
                    {},
                    {},
                ];
            }
            const lastColumn = isPIML ? 8 : 6

            const cellsToUnderline = [
                { row: extractedData.length + (totalsData.length - 2), column: lastColumn, type: 'single' },
                { row: extractedData.length + totalsData.length, column: lastColumn, type: 'single' },
            ];

            const columnStyles = {
                1: { halign: 'right' },
                3: { halign: 'left' },
                4: { halign: isPIML ? 'left' : 'right' },
                5: { halign: isPIML ? 'left' : 'right' },
                6: { halign: 'right' },
            };

            if (isPIML) {
                columnStyles[7] = { halign: 'right' };
                columnStyles[8] = { halign: 'right' };
            }
            // Single table
            doc.autoTable({
                theme: 'plain',
                head: [tableColumn.map(col => col.header)],
                body: extractedDataWithTotals.map(row => Object.values(row)),
                startY: othsinTableStartY,
                styles: { fontSize: 8 },
                margin: { left: 31, right: 31, top: 100, bottom: 200 },
                headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: 'center' },
                bodyStyles: { halign: 'center' },
                columnStyles: columnStyles,
                tableLineColor: [0, 0, 0],
                tableLineWidth: 0.5,
                pageBreak: 'auto',
                didDrawCell: function (data) {
                    const shouldUnderline = cellsToUnderline.find(
                        cell => cell.row === data.row.index && cell.column === data.column.index
                    );

                    if (shouldUnderline) {
                        const { x, y, width } = data.cell;
                        doc.setDrawColor(0);
                        doc.setLineWidth(0.5);

                        if (shouldUnderline.type === 'single') {
                            doc.line(x, y, x + width, y);
                        }
                    }
                    if (data.section === "head" && data.row.index === 0) {
                        const { y, height } = data.cell;
                        const fullTableWidth = data.table.columns.reduce((sum, col) => sum + col.width, 0);
                        doc.setDrawColor(0);
                        doc.setLineWidth(0.5);
                        doc.line(
                            data.table.settings.margin.left,
                            y + height,
                            data.table.settings.margin.left + fullTableWidth,
                            y + height
                        );
                    }

                },
                didDrawPage: (data) => {
                    const pageCount = doc.internal.getNumberOfPages();
                    const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
                    // Add header on each page
                    addHeader(doc, siteData, companyData, documentDetails, xLeftKey, pageWidth, currentPage, pageCount);
                    // Add footer on each page
                    addFooter(doc, pageWidth, pageHeight, currentPage, pageCount);
                },
            });
            let vatTableY = doc.lastAutoTable.finalY;
            doc.setFontSize(8);
            doc.setFontStyle("normal");
            doc.text(`  Total Quantity                     ${totalQuantity}`, 31, vatTableY + 10);

            vatTableY += 0;
            const tableBody = [];
            const maxRows = Math.max(vatDetails.length, vatCalculationsData.length);

            for (let i = 0; i < maxRows; i++) {
                const vatDetail = vatDetails[i] || { label: '', value: '' };
                const vatCalc = vatCalculationsData[i] || { label: '', value: '' };

                tableBody.push([
                    '',
                    '',
                    vatDetail.label,
                    vatDetail.value,
                    '',
                    vatCalc.label,
                    vatCalc.value
                ]);
            }
            const vatCellsToUnderline = [
                { row: 2, column: 6, type: 'single' },
                { row: 4, column: 6, type: 'single' },
                { row: 6, column: 6, type: 'single' },

            ];
            // Create the table
            doc.autoTable({
                theme: 'plain',
                head: [['', '', '', '', '', '', '']], // Empty header for spacing
                body: tableBody,
                startY: vatTableY,
                tableLineColor: [0, 0, 0],
                tableLineWidth: 0.5,
                styles: {
                    fontSize: 8,
                    cellPadding: { top: 1, right: 2, bottom: 1, left: 2 },
                },
                margin: { left: 31, right: 31 },
                columnStyles: {
                    0: {
                        cellWidth: 200
                    },
                    1: {
                        cellWidth: 10
                    },
                    2: {
                        cellWidth: 'auto',
                        halign: 'left'
                    },
                    3: {
                        cellWidth: 60,
                        halign: 'right'
                    },
                    4: {
                        cellWidth: 20
                    },
                    5: {
                        cellWidth: 'auto',
                        halign: 'left'
                    },
                    6: {
                        cellWidth: 60,
                        halign: 'right'
                    }
                },
                willDrawCell: function (data) {
                    const shouldUnderlineVat = vatCellsToUnderline.find(
                        cell => cell.row === data.row.index && cell.column === data.column.index
                    );

                    if (shouldUnderlineVat) {
                        const { x, y, width } = data.cell;
                        doc.setDrawColor(0);
                        doc.setLineWidth(0.5);

                        if (shouldUnderlineVat.type === 'single') {
                            doc.line(x, y, x + width, y);
                        }
                    }

                    if (data.row.index === tableBody.length - 1 && data.column.index === 6) {
                        doc.setFont('helvetica', 'bold');
                    }

                },
            });

            doc.setDrawColor(0, 0, 0);
            doc.setLineWidth(1);
            // Footer and Page Numbers
            let finalY = doc.lastAutoTable.finalY + 20;
            //doc.text('--- Nothing Follows---', pageWidth / 2, finalY - 10, { align: 'center' });

            // Totals and Additional Information on the last page
            if (finalY + 220 > pageHeight) {
                doc.addPage();
                const pageCount = doc.internal.getNumberOfPages();
                const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
                addHeader(doc, siteData, companyData, documentDetails, xLeftKey, pageWidth, currentPage, pageCount);
                finalY = 100;
                addFooter(doc, pageWidth, pageHeight, currentPage, pageCount);
            }

            const pageCount = doc.internal.getNumberOfPages();
            for (var i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.text('Page ' + i + ' of ' + pageCount, pageWidth - 120, 30);
            }
            // Conditions 
            doc.setFontSize(8);
            doc.text('CONDITIONS:', 40, finalY);
            doc.text('Customer acknowledges receipt of the above items in good order and condition.', 40, finalY + 15);
            doc.text('All items described herein shall remain to be property of this Company until fully paid for. All unpaid portion will be charged a penalty of 5% per month.', 40, finalY + 30);
            doc.text('Parties agree to submit to the jurisdiction of the court of the City of Manila in case of legal action arising from this transaction.', 40, finalY + 45);

            // Signature
            finalY += 75; // Increased spacing
            doc.setFontSize(8);
            doc.text('Authorized Signature', 270, finalY + 35);
            doc.text('_________________________________', 235, finalY + 20);
            doc.text("Customer's Printed Name & Signature/Date", 400, finalY + 35);
            doc.text('_________________________________', 400, finalY + 20);

            doc.setFontSize(7);
            doc.setFontStyle("italic");
            doc.text(' This is system generated invoice', 255, finalY + 45);
            doc.text(' Valid without signature if there are no alterations ', 235, finalY + 55);

            // Document Info
            finalY += 60; // Increased spacing
            doc.setFontSize(8);
            doc.setFont(undefined, 'bolditalic');
            doc.text(`"THIS DOCUMENT IS VALID FOR CLAIM OF INPUT TAX"`, pageWidth / 2, finalY + 20, { align: 'center' });

            // Generate the PDF as a data URI
            //var pdfDataUri = doc.output('datauristring');

            // Open the PDF in a new tab
            // var win = window.open();
            // win.document.write('<iframe src="' + pdfDataUri + '" style="border: none; width: 100%; height: 100%;"></iframe>');

            // Save the PDF
            // doc.save('invoice.pdf');
            let pdfWindow = window.open(doc.output('bloburl'), '_blank');
            const detectBrowser = () => {
                const agent = window.navigator.userAgent.toLowerCase();
                if (agent.indexOf('edg') > -1) return 'Microsoft Edge';
                if (agent.indexOf('chrome') > -1) return 'Google Chrome';
                if (agent.indexOf('safari') > -1) return 'Safari';
                return 'Not Supported Browser';
            };

            const detectColorScheme = () => {
                if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                    return 'dark';
                }
                return 'light';
            };

            const browserName = detectBrowser();
            const colorScheme = detectColorScheme();
            const browserColors = {
                'Google Chrome': {
                    dark: 'rgb(51, 54, 57)',
                    light: 'white'
                },
                'Microsoft Edge': {
                    dark: 'rgb(59, 59, 59)',
                    light: 'rgb(247, 247, 247)'
                },
                'Safari': {
                    dark: 'rgb(44, 44, 44)',
                    light: 'white'
                },
                'default': {
                    dark: 'rgb(30, 33, 36)',
                    light: 'white'
                }
            };
            const getBackgroundColor = () => {
                const browserColorConfig = browserColors[browserName] || browserColors['default'];
                return browserColorConfig[colorScheme];
            };

            if (!isPrinted) {
                pdfWindow.addEventListener('load', () => {
                    const printButton = pdfWindow.document.createElement('button');
                    printButton.style.position = 'fixed';
                    printButton.style.top = browserName == 'Microsoft Edge' ? '2px' : '10px';
                    printButton.style.right = '10px';
                    printButton.style.zIndex = '9999';
                    printButton.style.marginRight = '44px';
                    printButton.style.backgroundColor = getBackgroundColor();
                    printButton.style.border = 'none';
                    printButton.style.padding = browserName == 'Microsoft Edge' ? '10px 40px' : '10px 20px';
                    printButton.style.cursor = 'pointer';
                    printButton.style.color = colorScheme == 'dark' ? 'white' : 'black'
                    printButton.style.fontSize = '15px'

                    const fontAwesomeLink = pdfWindow.document.createElement('link');
                    fontAwesomeLink.rel = 'stylesheet';
                    fontAwesomeLink.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
                    pdfWindow.document.head.appendChild(fontAwesomeLink);

                    printButton.innerHTML = '<i class="fas fa-print"></i> Print';

                    printButton.addEventListener('click', () => {
                        pdfWindow.print()
                        this.create_action_history('Print Document', documentDetails.id)
                    });
                    pdfWindow.document.body.appendChild(printButton);
                });
            }

            component_x.spinning = false;

        },
        async create_action_history(action, doc_no) {
            var actionHistoryPayload = {
                action: action,
                action_at: moment(new Date()),
                action_by: secureStorage.getItem("userName"),
                document_id: doc_no,
                status: "A"
            }
            await HTTPRequest.postRequest(this.endPoint + 'document_action_histories/', null, actionHistoryPayload)
        },
    }
};

export default printOthsin; // export the mixin
